import AboutSection from "./AboutSection";
import GallerySection from "./GallerySection";
import MainSection from "./MainSection";
import FaqSection from "./FaqSection";
import RoadMapSection from "./RoadmapSection";
import DevRoadmap from "./DevRoadmap";
import TeamSection from "./TeamSection";
import FooterSection from "./FooterSection";
import SaleSection from "./SaleSection";
import GeneralsSection from "./GeneralsSection";

const HomePage = () => {
  return (
    <>
      <MainSection></MainSection>
      <SaleSection></SaleSection>
      <GallerySection></GallerySection>
      <AboutSection></AboutSection>
      <RoadMapSection></RoadMapSection>
      <DevRoadmap></DevRoadmap>
      <GeneralsSection></GeneralsSection>
      <TeamSection></TeamSection>
      <FaqSection></FaqSection>
      <FooterSection></FooterSection>
    </>
  );
};

export default HomePage;
